import Keyboard from "react-simple-keyboard";
import { TecladoAlfanumericoContainer } from "./localStyle";
import "react-simple-keyboard/build/css/index.css";

/*
  TecladoAlfanumericoV2: versión que soporta múltiples inputs con foco dinámico.
  Props:
  - onKeyToField(fieldName, nextValue): callback para actualizar el campo activo
  - activeField: nombre del campo activo
  - onEnter: acción Enter (ej. enviar)
  - enterStr: etiqueta del Enter
  - modeLight: tema claro/oscuro
  - sinNumeros: true si se ocultan números, false si se muestran
*/
const TecladoAlfanumericoV2 = ({
  onKeyToField,
  activeField,
  onEnter,
  enterStr,
  modeLight,
  sinNumeros,
}) => {
  const onKeyPress = (button) => {
    if (button === "{enter}") return onEnter && onEnter();
    if (button === "{bksp}") return pushToField("{bksp}");
  };

  const onChange = (input) => {
    // react-simple-keyboard envía el string completo; delegamos a pushToField incrementalmente si se requiere
  };

  const pushToField = (key) => {
    if (!activeField || !onKeyToField) return;
    onKeyToField(activeField, key);
  };

  const onKeyReleased = (button) => {
    // No-op
  };

  const defaultLayout = [
    "1 2 3 4 5 6 7 8 9 0  ",
    "Q W E R T Y U I O P  ",
    "A S D F G H J K L Ñ {bksp}",
    "Z X C V B N M {space} {enter}",
  ];
  const layoutSinNumeros = [
    "Q W E R T Y U I O P ",
    "A S D F G H J K L Ñ {bksp}",
    "Z X C V B N M {space} {enter}",
  ];

  return (
    <TecladoAlfanumericoContainer
      $modeLight={modeLight}
      $sinNumeros={sinNumeros}
    >
      <Keyboard
        maxLength={128}
        layoutName={"default"}
        onChange={onChange}
        theme={"hg-theme-default myTheme1 rb24m"}
        onKeyPress={(btn) => {
          if (btn === "{enter}") return onEnter && onEnter();
          if (btn === "{bksp}") return pushToField("{bksp}");
          if (btn === "{space}") return pushToField(" ");
          pushToField(btn);
        }}
        onKeyReleased={onKeyReleased}
        layout={{
          default: sinNumeros ? layoutSinNumeros : defaultLayout,
        }}
        display={{
          "{enter}": enterStr || "Aceptar",
          "{escape}": "esc ⎋",
          "{space}": "Espacio",
          "{bksp}": "Borrar",
        }}
        buttonTheme={[
          {
            class: modeLight ? "hg-white" : "hg-latex10",
            buttons:
              "1 2 3 4 5 6 7 8 9 0 Q W E R T Y U I O P A S D F G H J K L Ñ Z X C V B N M",
          },
          {
            class: "hg-broccoli",
            buttons: "{enter}",
          },
          {
            class: "hg-danger",
            buttons: "{bksp}",
          },
          {
            class: "hg-space",
            buttons: "{space}",
          },
          {
            class: "hg-empty",
            buttons: " ",
          },
        ]}
      />
    </TecladoAlfanumericoContainer>
  );
};

export default TecladoAlfanumericoV2;
